export class UnsuccessfulApiCall extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, UnsuccessfulApiCall.prototype);
  }
}
